import Button from 'common/Button/Button';
import { Link, useHistory } from 'react-router-dom';
import './NotFound.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Сторінка 404 — ADR-0008.
 * Прибрано window.scrollTo(0, 0) у JSX та емодзі з тексту: скрінрідер зачитує
 * його вголос, а на офіційному сайті він тут ні до чого.
 */
export default function NotFound() {
  const language = useLanguage();
  const { replace } = useHistory();

  return (
    <article className='not-found section'>
      <div className='container not-found-wrapper'>
        <span className='not-found-code tnum' aria-hidden='true'>
          404
        </span>

        <h1 className='not-found-title'>
          {language === 'en' ? 'This page does not exist' : 'Такої сторінки не існує'}
        </h1>

        <p className='not-found-text'>
          {language === 'en'
            ? 'The page may have been moved or the address contains a mistake.'
            : 'Можливо, сторінку перенесли або в адресі є помилка.'}
        </p>

        <div className='not-found-actions'>
          <Button variant='primary' buttonText={language === 'en' ? 'Home' : 'На головну'} onClick={() => replace('/')} />
          <Link className='btn btn--secondary' to='/catalogs'>
            {language === 'en' ? 'Registers' : 'Реєстри'}
          </Link>
          <Link className='btn btn--secondary' to='/calendar'>
            {language === 'en' ? 'Calendar' : 'Календар'}
          </Link>
        </div>
      </div>
    </article>
  );
}
